/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcPortfolioV1PerformanceServicePerformancePerformanceRequest, IxcPortfolioV1PerformanceServicePerformanceResponse } from '@interxfi/types';

export const IXC_PORTFOLIO_V1_PERFORMANCE_SERVICE_PERFORMANCE_AUDIENCE = ['clearing', 'program'];

export async function ixcPortfolioV1PerformanceServicePerformance(baseUrl: string | undefined, request?: IxcPortfolioV1PerformanceServicePerformancePerformanceRequest, requestInit?: RequestInit): Promise<IxcPortfolioV1PerformanceServicePerformanceResponse | undefined> { return makeRequest<IxcPortfolioV1PerformanceServicePerformanceResponse, IxcPortfolioV1PerformanceServicePerformancePerformanceRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/portfolio/v1/performance/:accountId', request, requestInit)); }

